// this file is automatically generated by git.revision.js script
export const versions = { revision: '114c4e86c2' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '114c4e86c2';
